
import { environment } from "../../environments/environment";

export const ViewConstants = {
	
	TabView_Open: 'TabView_Open',
	
	ToolsTaskViewer: 'TaskViewer',
	
	VehicleEdit: 'VehicleEdit',
	
	SaleEdit: 'SaleEdit',

	OpportunityActivityEdit: 'OpportunityActivityEdit',

    ContactEdit: 'ContactEdit',

    OpportunityEdit: 'OpportunityEdit',
}


export const EmbeddedViewConstants = {

	TabView_Open: ViewConstants.TabView_Open,
	
	ToolsTaskViewer: ViewConstants.ToolsTaskViewer,

	VehicleEdit: ViewConstants.VehicleEdit,

	SaleEdit: ViewConstants.SaleEdit

}